import React, {FC} from 'react'
import InputMask from 'react-input-mask'

type props = {
  mask: string
  placeholder: string
  name: string
  onBlur: any
  onChange: any
  value: string
  className?: any
}

const MaskInput: FC<props> = (props) => {
  return (
    <InputMask autoComplete='off' {...props}>
      {(inputProps: any) => (
        <input
          className={
            props.className ?? 'form-control form-control-lg form-control-solid mb-3 mb-lg-0'
          }
          {...inputProps}
        />
      )}
    </InputMask>
  )
}

export default MaskInput
